import React, { useState } from "react";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import Button from "@mui/material/Button/Button";
import Typography from "@mui/material/Typography/Typography";


/**
 * Creates a yes/no prompt dialog with a title and message.
 */
export function useUserPrompt() {
    const [open, setOpen] = useState<boolean>(false);
    const [title, setTitle] = useState<string>("");
    const [message, setMessage] = useState<string>("");
    const [userSelection, setUserSelection] = useState<boolean>(false);
    const [isSelected, setIsSelected] = useState<boolean>(false);
    const [oneButton, setOneButton] = useState<boolean>(false);
    /**
     * 
     * @param title Title of the dialog
     * @param message Dialog message
     * @param oneButtonForPrompt Whether to show only one button
     */
    const openDialog = (title: string, message: string, oneButtonForPrompt: boolean = false) => {
        setTitle(title);
        setMessage(message);
        setOpen(true);
        setIsSelected(false);
        setOneButton(oneButtonForPrompt);
    };

    const closeDialog = () => {
        setOpen(false);
        setIsSelected(true);
    };
    const buttons = !oneButton? <>
        <Button onClick={() => {
            setUserSelection(false);
            closeDialog();
        }}>No</Button>
        <Button onClick={() => {
            setUserSelection(true);
            closeDialog();
        }}>Yes</Button>
    </> : <>
        <Button onClick={() => {
            setUserSelection(false);
            closeDialog();
        }}>Close</Button>
    </>;
    const component = <Dialog open={open}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
            <Typography>
                {message}
            </Typography>
        </DialogContent>
        <DialogActions>
            {buttons}
        </DialogActions>
    </Dialog>;

    return {
        component,
        openDialog,
        userSelection,
        isSelected
    };
}